import { useReactNodeView } from '../utils/ReactNodeView';
import { jsx as _jsx } from "react/jsx-runtime";
export default function MeetingTimesView() {
  var _node$attrs;
  const {
    node
  } = useReactNodeView();
  return /*#__PURE__*/_jsx("div", {
    dangerouslySetInnerHTML: {
      __html: node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.timeBlockContent
    }
  });
}
export const meetingTimesViewUpdateFn = ({
  previousNode,
  node
}) => {
  if (previousNode.attrs.timeBlockContent !== node.attrs.timeBlockContent) {
    return false;
  }
  return true;
};